module.exports = __webpack_public_path__ + "img/article_10_3.1a244c64.png";